import { connect } from 'react-redux';
import DesktopTopbar, { Props } from '@components/DesktopTopbar';
import type { UserState } from '@user/redux/reducers';
import {
  getDaysUntilTrialEnds,
  getDefaultCreditCard,
} from '@user/redux/selectors';

const mapStateToProps = (state): Props => {
  const {
    location: { type },
  }: {
    user: UserState;
    location: any;
  } = state;

  const defaultCreditCard = getDefaultCreditCard(state);
  return {
    hasPaymentDetails:
      defaultCreditCard !== null &&
      defaultCreditCard.lastFour !== undefined &&
      defaultCreditCard.lastFour.length > 0,
    location: type,
    daysUntilTrialEnds: getDaysUntilTrialEnds(state),
  };
};

export default connect(mapStateToProps)(DesktopTopbar);
